import type { GameManifest } from "@cloudnest/board-game-runtime";

export function buildGameCatalogEntryTestId(gameType: string): string {
  return `enter-game-${gameType}`;
}

export function formatRulesetLabel(manifest: GameManifest): string {
  return `rules ${manifest.rulesetVersion} · protocol ${manifest.eventProtocolVersion}`;
}

export function formatRuntimeLabel(manifest: GameManifest): string {
  const ruleServiceRef = manifest.runtimePin?.ruleServiceRef ?? "unassigned";
  return `${ruleServiceRef} · ${manifest.projectionPolicy}`;
}

export function formatPlayerCountLabel(manifest: GameManifest): string {
  if (manifest.minPlayers === manifest.maxPlayers) {
    return `${manifest.minPlayers}인`;
  }
  return `${manifest.minPlayers}~${manifest.maxPlayers}인`;
}

export function formatObserverSupportLabel(manifest: GameManifest): string {
  return manifest.supportsObservers ? "관전 가능" : "관전 없음";
}
